import { genericEventHandler } from "@/analytics/events";
import { EventNames, GlobalEvents } from "@/analytics/events/constants";
import { Terms } from "@/components/account/rewards/terms";
import StringAccessor from "@/components/cmsConfig/stringAccessor";
import { Modal } from "@/components/uielements/modal";
import { StyledPrimaryButton } from "@/components/uielements/primaryButton/styles";
import {
  StyledRewardsButtonHeader,
  StyledRewardsFooterBox,
} from "@/components/uielements/reward/styles";
import { useSelector } from "@/redux";

interface Props {
  externalURL: string | null;
}

export const HowRewardsWork = ({ externalURL }: Props) => {
  const { organization } = useSelector((state) => state.app.organization);
  const label = <StringAccessor accessor="rewards.learn_more_button" />;
  const ariaLabel = "Click to learn how rewards work";

  // Fire KA Event
  const fireAnalyticsEvent = () =>
    genericEventHandler(GlobalEvents.GENERIC__CTA, {
      name: EventNames.HOW_REWARDS_WORK,
      details: "Rewards",
    });

  return (
    <StyledRewardsFooterBox>
      <StringAccessor
        tag={StyledRewardsButtonHeader}
        accessor="rewards.learn_more_header"
        html={true}
        dataObj={{ brand: organization.label }}
      />

      {externalURL ? (
        <StyledPrimaryButton
          aria-label={ariaLabel}
          as="a"
          href={externalURL}
          target="_blank"
          onClick={() => fireAnalyticsEvent()}
        >
          {label}
        </StyledPrimaryButton>
      ) : (
        <Modal.Container
          trigger={(open) => (
            <StyledPrimaryButton
              aria-label={ariaLabel}
              onClick={() => {
                open();
                fireAnalyticsEvent();
              }}
            >
              {label}
            </StyledPrimaryButton>
          )}
        >
          <Terms />
        </Modal.Container>
      )}
    </StyledRewardsFooterBox>
  );
};
